import BaseApi from './baseApi';
import IForm from '../models/IForms';
import IAuthentication from '../models/IAuthentication';
export default class FormApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "Roles");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetForms() : Promise<IForm[]> {
        const json = this.getJsonRead();
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var forms: IForm[] = [];
            forms = response.data as IForm[];
            return forms;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveForm(form: IForm) : Promise<string> {
        const json = this.getJsonSave(form);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateForm(form: IForm) : Promise<boolean> {
        const json = this.getJsonUpdate(form);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteForm(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "Forms",
            "conditions": [{
                "Item1": "Forms",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(form: IForm) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": form.formName
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "Forms"
        };
        return json;
    }

    private getJsonUpdate(form: IForm) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "Name",
                "Item2": form.formName
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "Forms",
            "keyvalue": form.id
        };
        return json;
    }

    private getJsonRead() : any {
        const json = {
            "fields": [{
                "Item1": "Forms",
                "Item2": "id"
            }, {
                "Item1": "Forms",
                "Item2": "formName"
            }],
            "tables": [{
                "Item1": "Forms"
            }],
            "conditions": [{
                "Item1": "Forms",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0"
            }]
        };
        return json;
    }
}
